// extracted by mini-css-extract-plugin
export var bubble = "_3z-0";
export var container = "_3z-f";
export var contrastBorder = "_3z-g";
export var greyOut = "_3z-2";
export var initialsColor0 = "_3z-3";
export var initialsColor1 = "_3z-4";
export var initialsColor10 = "_3z-d";
export var initialsColor11 = "_3z-e";
export var initialsColor2 = "_3z-5";
export var initialsColor3 = "_3z-6";
export var initialsColor4 = "_3z-7";
export var initialsColor5 = "_3z-8";
export var initialsColor6 = "_3z-9";
export var initialsColor7 = "_3z-a";
export var initialsColor8 = "_3z-b";
export var initialsColor9 = "_3z-c";
export var initialsWrapper = "_3z-1";
export var large = "_3z-l";
export var medium = "_3z-k";
export var mediumSmall = "_3z-j";
export var mediumSmallMedium = "_3z-o";
export var micro = "_3z-h";
export var small = "_3z-i";
export var tiny = "_3z-n";
export var xTiny = "_3z-m";